// Nav dropdowns — "The Work" (every project in PROJECTS, project-data.js)
// and "Services" (every slug in SERVICE_INDEX, services-data.js), so new
// projects/services show up automatically, no per-page edits. Both share
// one fixed panel instead of one each — only one is ever open at a time,
// and it's the same panel repositioned/repopulated under whichever
// trigger is active, rather than duplicating the CSS/positioning logic
// per trigger. Rendered as a fixed sibling of <nav>, positioned under the
// active trigger via JS, because nav's own mix-blend-mode:difference
// would otherwise swallow a child panel's background if it were nested
// inside nav.
(function () {
  const dropdown = document.getElementById('nav-dropdown');
  if (!dropdown) return;

  const groups = [];
  const workTrigger = document.getElementById('nav-work-trigger');
  if (workTrigger && typeof PROJECTS !== 'undefined') {
    groups.push({
      trigger: workTrigger,
      links: Object.values(PROJECTS).map((p) => ({ href: `/pages/${p.slug}`, label: p.title })),
    });
  }
  const servicesTrigger = document.getElementById('nav-services-trigger');
  if (servicesTrigger && typeof SERVICE_INDEX !== 'undefined') {
    groups.push({
      trigger: servicesTrigger,
      links: SERVICE_INDEX.map((s) => ({ href: `/pages/${s.slug}`, label: s.name })),
    });
  }
  if (!groups.length) return;

  let active = null;

  function position(trigger) {
    const r = trigger.getBoundingClientRect();
    const maxLeft = window.innerWidth - dropdown.offsetWidth - 8;
    dropdown.style.left = Math.max(8, Math.min(r.left, maxLeft)) + 'px';
    dropdown.style.top = (r.bottom + 10) + 'px';
  }

  function open(group) {
    active = group;
    dropdown.innerHTML = group.links.map((l) => `<a href="${l.href}">${l.label}</a>`).join('');
    position(group.trigger);
    dropdown.classList.add('open');
  }
  function close() { dropdown.classList.remove('open'); active = null; }
  function closeIfOutside() {
    if (!dropdown.matches(':hover') && !(active && active.trigger.matches(':hover'))) close();
  }

  groups.forEach((group) => {
    const { trigger } = group;
    trigger.addEventListener('mouseenter', () => open(group));
    trigger.addEventListener('focus', () => open(group));
    trigger.addEventListener('mouseleave', () => setTimeout(closeIfOutside, 80));
    // Hover has no equivalent on touch devices — tap-to-toggle so both
    // dropdowns stay usable on mobile.
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      (dropdown.classList.contains('open') && active === group) ? close() : open(group);
    });
  });
  dropdown.addEventListener('mouseenter', () => { if (active) position(active.trigger); });
  dropdown.addEventListener('mouseleave', () => setTimeout(closeIfOutside, 80));
  window.addEventListener('scroll', close, { passive: true });
  window.addEventListener('resize', close);
  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target) && !groups.some((g) => e.target === g.trigger)) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dropdown.classList.contains('open')) {
      close();
      if (active) active.trigger.focus();
    }
  });
})();
